/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { FoldersControllerFindOneQueryResponse, FoldersControllerFindOnePathParams, FoldersControllerFindOneQueryParams, FoldersControllerFindOne400, FoldersControllerFindOne401, FoldersControllerFindOne403, FoldersControllerFindOne404 } from "../../models/foldersController/FoldersControllerFindOne";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { foldersControllerFindOne } from "../../clients/foldersService/foldersControllerFindOne";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const foldersControllerFindOneQueryKey = (id: FoldersControllerFindOnePathParams["id"], params: FoldersControllerFindOneQueryParams = {}) => [{
  url: '/api/v1/folders/:id',
  params: {
    id: id
  }
}, ...(params ? [params] : [])] as const;
export type FoldersControllerFindOneQueryKey = ReturnType<typeof foldersControllerFindOneQueryKey>;
export function foldersControllerFindOneQueryOptions(id: FoldersControllerFindOnePathParams["id"], params?: FoldersControllerFindOneQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = foldersControllerFindOneQueryKey(id, params);
  return queryOptions<FoldersControllerFindOneQueryResponse, ResponseErrorConfig<FoldersControllerFindOne400 | FoldersControllerFindOne401 | FoldersControllerFindOne403 | FoldersControllerFindOne404>, FoldersControllerFindOneQueryResponse, typeof queryKey>({
    enabled: !!id,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return foldersControllerFindOne(id, params, config);
    }
  });
}

/**
 * @summary Get folder by id
 * {@link /api/v1/folders/:id}
 */
export function useFoldersControllerFindOne<TData = FoldersControllerFindOneQueryResponse, TQueryData = FoldersControllerFindOneQueryResponse, TQueryKey extends QueryKey = FoldersControllerFindOneQueryKey>(id: FoldersControllerFindOnePathParams["id"], params?: FoldersControllerFindOneQueryParams, options: {
  query?: Partial<QueryObserverOptions<FoldersControllerFindOneQueryResponse, ResponseErrorConfig<FoldersControllerFindOne400 | FoldersControllerFindOne401 | FoldersControllerFindOne403 | FoldersControllerFindOne404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? foldersControllerFindOneQueryKey(id, params);
  const query = useQuery({
    ...foldersControllerFindOneQueryOptions(id, params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<FoldersControllerFindOne400 | FoldersControllerFindOne401 | FoldersControllerFindOne403 | FoldersControllerFindOne404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}